import gql from 'graphql-tag';

/**
 * Data of the block project-customer-tax-bank: the five tax and bank fields on `customer`. Read
 * through `Project.blocks.customerTaxBank`, which checks the block's read permission.
 */
export const PROJECT_CUSTOMER_TAX_BANK_FIELDS = gql`
  fragment projectCustomerTaxBankFields on ProjectCustomerTaxBankBlock {
    id
    number
    customer {
      taxNumber
      bank
      iban
      bic
      accountHolder
    }
  }
`;
